export default "__VITE_ASSET__1371d523__"